<h3 mat-dialog-title>Selecciona el Tipo de Ticket</h3>
<mat-dialog-content
  class="column-base"
  style="
    height: auto;
    padding-bottom: 0px;
    margin-bottom: 0px;
    gap: 8px;
    display: flex;
  "
>
  <div class="Collapse-tb-cont">
    <div class="example-container-table">
      <table class="w-100" mat-table [dataSource]="dataSource" id="mi-tabla">
        <!-- Tipo de Ticket -->
        <ng-container matColumnDef="tipo">
          <th mat-header-cell *matHeaderCellDef class="column-170">
            Tipo de Ticket
          </th>
          <td mat-cell *matCellDef="let element" class="column-170">
            {{ element.tipo }}
          </td>
        </ng-container>

        <!-- Monto -->
        <ng-container matColumnDef="monto">
          <th mat-header-cell *matHeaderCellDef class="column-105">Monto</th>
          <td mat-cell *matCellDef="let element" class="column-105">
            {{ formatMoney(element.monto) }}
          </td>
        </ng-container>

        <!-- Cantidad -->
        <ng-container matColumnDef="cantidad">
          <th mat-header-cell *matHeaderCellDef class="column-105">Cantidad</th>
          <td mat-cell *matCellDef="let element" class="column-105">
            <div class="pax-counterv2">
              <button
                type="button"
                class="pax-counterv2__btn"
                (click)="handleChangeQuantity(element, element.cantidad - 1)"
                [disabled]="element.monto === '' || element.cantidad <= element.min"
                aria-label="Disminuir cantidad"
              >
                <i-tabler name="circle-minus" class="icon-16"></i-tabler>
              </button>

              <div class="pax-inputv2">
                <input
                  type="number"
                  [value]="element.cantidad"
                  [min]="element.min"
                  [disabled]="element.monto === ''"
                  (input)="handleChangeQuantity(element, $event)"
                />
              </div>

              <button
                type="button"
                class="pax-counterv2__btn"
                (click)="handleChangeQuantity(element, element.cantidad + 1)"
                [disabled]="element.monto === ''"
                aria-label="Aumentar cantidad"
              >
                <i-tabler name="circle-plus" class="icon-16"></i-tabler>
              </button>
            </div>
          </td>
        </ng-container>

        <!-- Total -->
        <ng-container matColumnDef="total">
          <th mat-header-cell *matHeaderCellDef class="column-170">Total</th>
          <td mat-cell *matCellDef="let element" class="column-170">
            {{ formatMoney(element.total) }}
          </td>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="['tipo', 'monto', 'cantidad', 'total']"
        ></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: ['tipo', 'monto', 'cantidad', 'total']"
        ></tr>
      </table>
    </div>

    <!-- Resumen y Total -->
    <div class="resumen-total-cont column-base" style="gap: 30px">
      <div class="resumen-cont column-base" style="gap: 16px">
        <div class="sub-tittle">Resumen</div>
        <div class="chosen-tickets" [innerHTML]="resumen || '-'"></div>
      </div>
      <div class="total-cont column-base" style="gap: 16px">
        <div class="sub-tittle">Total</div>
        <ng-container *ngIf="totalGeneral === 0; else showTotal">
          <span style="color: #808080">-</span>
        </ng-container>
        <ng-template #showTotal>
          <div class="total-tickets">
            {{ moneda }} {{ totalGeneral | formatNumber }}
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="div-center" style="gap: 30px">
  <button
    mat-flat-button
    style="min-height: 36px; width: 130px; box-shadow: none !important"
    (click)="onCancel()"
    class="buttonSecundary"
  >
    Cancelar
  </button>

  <button
    mat-flat-button
    (click)="onSave()"
    class="buttonPrimary row-base div-center div-vertical-center white-spinner"
    style="
      gap: 4px;
      width: 130px;
      box-shadow: none !important;
      min-height: 36px;
    "
    [style.cursor]="loading ? 'not-allowed' : 'pointer'"
    [disabled]="!hasChanges || loading"
  >
    <div *ngIf="loading" class="w-100 div-center">
      <mat-spinner [diameter]="20"></mat-spinner>
    </div>
    <div *ngIf="!loading">Guardar Cambios</div>
  </button>
</mat-dialog-actions>
